import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { CalendarHeart, MessageCircle } from "lucide-react";
import { EASE } from "./Motion";
import { api } from "../../lib/api";
import { waLink } from "../../lib/catalog";

const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-IN", { day: "numeric", month: "long" });

export const FestivalBanner = () => {
  const { data } = useQuery({ queryKey: ["festival"], queryFn: () => api.get("/festival").then((r) => r.data), retry: false });
  if (!data?.active) return null;
  return (
    <section className="relative overflow-hidden bg-gold-foil text-[#240620]" data-testid="festival-banner">
      <div className="pointer-events-none absolute -right-20 -top-24 h-72 w-72 rounded-full bg-[#E91E63]/20 blur-[90px]" />
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.8, ease: EASE }}
        className="relative mx-auto flex max-w-[1440px] flex-col gap-6 px-5 py-10 sm:px-8 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-3xl">
          <p className="flex items-center gap-2 font-cinzel text-xs uppercase tracking-[0.3em] text-[#6b1550]">
            <CalendarHeart size={15} /> Festival special{data.end_date ? ` · book by ${fmt(data.end_date)}` : ""}
          </p>
          <h2 className="mt-3 font-display text-4xl font-semibold leading-[0.95] sm:text-5xl" data-testid="festival-title">{data.title}</h2>
          {data.message && <p className="mt-3 text-base leading-relaxed text-[#3d0f37]" data-testid="festival-message">{data.message}</p>}
        </div>
        <div className="flex shrink-0 flex-wrap gap-3">
          <Link to="/c/festive-offers" className="rounded-full bg-[#240620] px-6 py-3 text-sm font-semibold text-[#F3E5AB] transition-transform duration-300 hover:scale-105" data-testid="festival-book-btn">See festive offers</Link>
          <a href={waLink(`Hi PetalBasket, I'd like to book flowers for ${data.title}.`)} target="_blank" rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-[#240620]/40 px-6 py-3 text-sm font-semibold transition-colors duration-300 hover:bg-[#240620]/10" data-testid="festival-whatsapp-btn">
            <MessageCircle size={16} /> WhatsApp us
          </a>
        </div>
      </motion.div>
    </section>
  );
};
